import { IProviderConfig } from '../../services/common/provider-config'
import { Entity } from '../entity'

export interface IAnalyticsTagManager {
    gtm: string[]
    comScore?: string
    gtm_params?: {
        html?: {
            env: string,
            auth: string,
            container_id: string
        }
    }
    permutive?: {
        organization_id: string,
        workspace_id: string,
        workspace_api_key: string,
        namespace: string
    }
    fullContact?: string,
    live_ramp?: string
    intentiq?: {
        partner_id: number
        ab_percentage?: number
        browser_blackList?: string
        timeout_in_millis?: number
    }
    optable?: {
        enabled: boolean
        slug: string
    }
    femUrl?: string
}

export interface IAnalyticsConfiguration {
    brand: string
    debug?: string
    division?: string
    domain: string
    provider: IProviderConfig
    tags?: IAnalyticsTagManager
}

export class AnalyticsConfiguration extends Entity implements IAnalyticsConfiguration {
    public brand: string
    public debug?: string
    public division?: string
    public domain: string
    public provider: IProviderConfig
    public tags?: IAnalyticsTagManager
    public platform: string
    public platformVersion: string
    public femVersion: string
    public isDev: boolean

    public fromJson(jsonObject: object): IAnalyticsConfiguration {
        super.fromJson(jsonObject)

        // parse provider object
        this.provider = (jsonObject as this).provider

        // parse tags object
        if ((jsonObject as this).tags) {
            this.tags = (jsonObject as this).tags
        }

        return this
    }
}
